<template>
  <div class="flex_vertial">
    <div style="flex: 1;"/>
    <div class="content">
      <div class="head_title">免费呼叫运营商开通服务</div>
      <div class="head_title_gray">运营商官方号码{{ openAiNum }}</div>
      <img class="guide_img" src="../../assets/callforwardguide.png">
    </div>
    <div style="flex: 1;"/>
    <div class="head_title_gray">使用号码{{ selfNum }}</div>
    <a v-if="openAiNum" class="open_button" @click="setCallForword" style="text-decoration: none">免费拨打开通服务</a>
  </div>
</template>

<script>


import {SERVICE_SWITCH} from '@/utils/const'
import lubanApi from '@/lubanApi'
import app from '@/AppData'
import util from '@/utils/util'
import jsbridge from '@/jsbridge'

export default {
  name: 'bindGuidePage',
  data () {
    return {
      openAiNum: '',
      selfNum: ''
    }
  },
  methods: {
    setCallForword () {
      var aiRedirectNum = util.getOpenAiPhoneNum(this.openAiNum)
      jsbridge.setAiRedirectCall(aiRedirectNum).then(res => {
        console.log('click setCallForword')
        // 点击了设置转接号码按钮，服务开关设置为打开状态
        app.putLocalStorage(SERVICE_SWITCH.NAME, SERVICE_SWITCH.STATE_OPEN)
        this.$router.replace({
          path: '/bind_dail_try'
        })

        jsbridge.setBindNum(app.getData().userSetting.phoneNum)
        lubanApi.reportseer('AICall_Open_Function_Setting_Page_Call_Button_Click')
      }).catch(err => {

      })
    }
  },
  mounted () {
    var that = this
    app.getCallForwardNum(true).then(res => {
      console.log('callfornum ' + res)
      that.openAiNum = res
      that.selfNum = app.getData().userSetting.phoneNum
      console.log('openAiNum', that.openAiNum)
    })
    lubanApi.reportseer('AICall_Open_Function_Open_SetCallForward_Show')
  }
}
</script>

<style scoped lang="less" src="@/styles/common.less"/>
<style scoped>
.content {
  width: 100%;
}

.guide_img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/bind/BindSetCallForward.vue